// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".allNfts{\r\n    margin-top: 2rem;\r\n    padding: 0 2rem\r\n}\r\n\r\n@media (max-width: 767px){\r\n    .allNfts{\r\n        margin-top: 10px;\r\n        padding: 0 10px\r\n    }\r\n}", ""]);
// Exports
module.exports = exports;
